export class SimpleStatisticsResponse {
  public spendingCurrentUsd: number = 0;
  public headCount: number = 0;
  public headCountCurrent?: number = 0;
  public spendingCurrentLcu: number = 0;
  public spending2021ppp: number = 0;
  public spendingMakeup: number = 0;
  public spendingFragrances: number = 0;
  public spendingHairCare: number = 0;
  public spendingAllPersonalCare: number = 0;
  public spendingSkinCare: number = 0;
  public spendingBeauty: number = 0;
  public spendingHygiene: number = 0;
  public spendingOtherPersonalCare: number = 0;
  public spendingFoodAndBeverages: number = 0;
  public spendingFoodAndBeveragesPPP: number = 0;
  public spendingSkinCarePPP: number = 0;
  public spendingHygienePPP: number = 0;
  public spendingHairCarePPP: number = 0;
  public spendingPersonalCarePPP: number = 0;
  public spendingMakeupPPP: number = 0;
  public spendingBeautyPPP: number = 0;
  public spendingFragrancesPPP: number = 0;
  public spendingOtherPersonalCarePPP: number = 0;
  public spendingOralCare: number = 0;
  public spendingOralCarePPP: number = 0;
  public spendingSpiritsPPP: number = 0;
  public spendingSpirits: number = 0;
  public spendingAlcoholicTobacco: number = 0;
  public spendingAlcoholicTobaccoPPP: number = 0;
  public spendingClothingFootwear: number = 0;
  public spendingClothingFootwearPPP: number = 0;
  public spendingHousing: number = 0;
  public spendingHousingPPP: number = 0;
  public spendingFurnishedHousehold: number = 0;
  public spendingFurnishedHouseholdPPP: number = 0;
  public spendingHealth: number = 0;
  public spendingHealthPPP: number = 0;
  public spendingTransport: number = 0;
  public spendingTransportPPP: number = 0;
  public spendingCommunication: number = 0;
  public spendingCommunicationPPP: number = 0;
  public spendingRecreationCulture: number = 0;
  public spendingRecreationCulturePPP: number = 0;
  public spendingEducation: number = 0;
  public spendingEducationPPP: number = 0;
  public spendingRestaurantsHotel: number = 0;
  public spendingRestaurantsHotelPPP: number = 0;
  public spendingMiscellaneous: number = 0;
  public spendingMiscellaneousPPP: number = 0;
  public spendingBeautyServices: number = 0;
  public spendingBeautyServicesPPP: number = 0;
  public spendingTotalBeauty: number = 0;
  public spendingTotalBeautyPPP: number = 0;
}
